module.exports = __webpack_public_path__ + "static/media/07AFCjianxiugong.46c67c6b.png";